import { render, staticRenderFns } from "./PreclinicalStudies.vue?vue&type=template&id=8eb7df08&scoped=true&"
var script = {}
import style0 from "./PreclinicalStudies.vue?vue&type=style&index=0&id=8eb7df08&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8eb7df08",
  null
  
)

export default component.exports